<template>
  <fieldset class="formsection">
    <header class="formsection__header">
      <legend class="formsection__header__title">{{ title }}</legend>
      <P v-if="description" class="formsection__header__desc">{{ description }}</P>
    </header>
    <slot></slot>
  </fieldset>
</template>

<script>
import P from "./P";

export default {
  name: "FormSection",
  components: {
    P,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: String,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import '~@/style/_variables.scss';
.formsection {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
  margin-bottom: $padding-md;
  min-inline-size: initial;

  &__header {
    margin-bottom: $padding-xl;

    &__title {
      width: 100%;
      font-size: $font-size-lg;
      font-weight: 500;
      padding-bottom: $padding-sm;
      color: $black;
      border-bottom: 1px solid $border-divide;
      box-sizing: border-box;
    }

    &__desc {
      margin-top: $padding-md;
    }
  }
}
</style>
